import { render, staticRenderFns } from "./listLead.vue?vue&type=template&id=c095c24e"
import script from "./listLead.vue?vue&type=script&lang=js"
export * from "./listLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports